import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AdminPanel = () => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [projectDetails, setProjectDetails] = useState({});
  const navigate = useNavigate();
  
  const api = axios.create({ baseURL: process.env.REACT_APP_API_BASE_URL });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user || user.email !== 'emreonyurt@gmail.com') {
      alert('Access denied.');
      navigate('/projects');
    }
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await api.get('/api/admin/users/recent', {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        setUsers(response.data);
      } catch (error) {
        console.error('Error fetching users:', error.message);
      }
    };
    fetchUsers();
  }, []);

  const fetchUserProjects = async (userId) => {
    try {
      const response = await api.get(`/api/admin/users/${userId}/projects`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setProjects(response.data);
      setSelectedUser(userId);
    } catch (error) {
      console.error('Error fetching projects:', error.message);
    }
  };

  const fetchProjectDetails = async (projectId) => {
    try {
      const [tasksRes, invitationsRes, membersRes] = await Promise.all([
        api.get(`/api/admin/projects/${projectId}/tasks`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }),
        api.get(`/api/admin/projects/${projectId}/invitations`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }),
        api.get(`/api/admin/projects/${projectId}/members`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }),
      ]);

      setProjectDetails({
        tasks: tasksRes.data,
        invitations: invitationsRes.data,
        members: membersRes.data,
      });

      setSelectedProject(projectId);
    } catch (error) {
      console.error('Error fetching project details:', error.message);
    }
  };

  return (
    <div>
      <h1>Admin Panel</h1>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Login Count</th>
            <th>Last Login</th>
            <th>Preffered Language</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{user.roleId}</td>
              <td>{user.login_count}</td>
              <td>{user.last_login_at}</td>
              <td>{user.preferred_language}</td>
              <td>
                <button onClick={() => fetchUserProjects(user.id)}>Projeler</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {selectedUser && (
        <div className="modal">
          <h2>Kullanıcı Projeleri</h2>
          <ul>
            {projects.map((project) => (
              <li key={project.id} onClick={() => fetchProjectDetails(project.id)}>
                {project.name}
              </li>
            ))}
          </ul>
        </div>
      )}

      {selectedProject && (
        <div className="modal">
          <h2>Proje Detayları</h2>
          <p>Görevler: {JSON.stringify(projectDetails.tasks)}</p>
          <p>Davetler: {JSON.stringify(projectDetails.invitations)}</p>
          <p>Üyeler: {JSON.stringify(projectDetails.members)}</p>
        </div>
      )}
    </div>
  );
};

export default AdminPanel;
